/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S5_HeadingInputs */

const tr_kvkkbasvuru_s5_heading = /** @type {(inputs: Kvkkbasvuru_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Başvuru Formu`)
};

const en_kvkkbasvuru_s5_heading = /** @type {(inputs: Kvkkbasvuru_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Application Form`)
};

const de_kvkkbasvuru_s5_heading = /** @type {(inputs: Kvkkbasvuru_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Antragsformular`)
};

const ru_kvkkbasvuru_s5_heading = /** @type {(inputs: Kvkkbasvuru_S5_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Форма обращения`)
};

/**
* | output |
* | --- |
* | "5. Application Form" |
*
* @param {Kvkkbasvuru_S5_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s5_heading = /** @type {((inputs?: Kvkkbasvuru_S5_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S5_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s5_heading(inputs)
	if (locale === "de") return de_kvkkbasvuru_s5_heading(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s5_heading(inputs)
	return tr_kvkkbasvuru_s5_heading(inputs)
});